module.exports = "/_next/static/images/f39197e8dd5b59c2f3bc34a621c18450-logo-cnn.png.webp";